import React from 'react';
import './BlogSingle.css';

// Importing necessary components, utilities, and icons
import { Comments, Lightbox, PageTitle, UniversalSidebar } from '../../../components';
import { blogContent } from '../../../constants';
import { extractDateParts, useFilter } from '../../../utils';

import { FaFacebookF, FaInstagram, FaLinkedin, FaQuoteLeft, FaTags, FaCheckCircle } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

import { Link, useLocation } from "react-router-dom";

const BlogSingle = () => {

  const {
    selectedCategory,
    selectedTag,
    handleSearchSubmit,
  } = useFilter(blogContent, 'blog');

  const location = useLocation();
  const blog = location.state;

  const { day, shortMonth } = extractDateParts(blog.date);

  return (
    <>
      <PageTitle title={blog.heading} page={"blog single"} />

      <section className='blog-single page-single'>

        <div className='blog-container'>

          <div className='blog-info page-info' key={blog.id}>

            <div className='image'>
              <img src={blog.image} alt={blog.heading} />
              <div className='date'><span>{day}</span> <br></br> {shortMonth}</div>
            </div>

            <div className='content'>

              <h3 className='main-heading'>{blog.heading}</h3>

              <div className='details'>
                <h3><span>By {blog.admin}</span></h3>
                <h3>
                  <div className='icon'><FaTags /></div>
                  <Link className='category' to={`/Blogs/category/${blog.category}`}>{blog.category}</Link>
                </h3>
              </div>

              {/* Important Quote Section */}
              <div className="imp">
                <div className="icon"><FaQuoteLeft /></div>
                <div className='box-container'>
                  "{blog.important.content}"
                  <div className='intro'>
                    <span></span>
                    <h6>{blog.important.intro}</h6>
                  </div>
                </div>
              </div>

              {/* Dynamic Points Section - Loops through points array */}
              <div className="blog-points">
                {blog.points && blog.points.map((point, index) => (
                  <div className="blog-point" key={index}>
                    <div className="point-title">
                      <FaCheckCircle className="point-icon" />
                      <h4>{point.title}</h4>
                    </div>
                    <p className="point-description">{point.description}</p>
                  </div>
                ))}
              </div>

              <div className='end-details'>

                <div className='tags'>
                  {blog.tags.map((item, index) => (
                    <Link className='item' key={index} to={`/Blogs/tag/${item}`}>
                      {item}
                    </Link>
                  ))}
                </div>

                <div className='share'>
                  <h3>share:</h3>
                  <a href="/#"><div className='icon'><FaFacebookF /></div></a>
                  <a href="/#"><div className='icon'><FaLinkedin /></div></a>
                  <a href="/#"><div className='icon'><FaXTwitter /></div></a>
                  <a href="/#"><div className='icon'><FaInstagram /></div></a>
                </div>

              </div>
            </div>
          </div>

        </div>

        <UniversalSidebar
          type="blog"
          selectedCategory={selectedCategory}
          selectedTag={selectedTag}
          handleSubmit={handleSearchSubmit}
        />

      </section>
    </>
  )
}

export default BlogSingle;